// Listings Store - localStorage-based data for services, marketplace, rentals, rides
// Can be migrated to backend later

const SERVICES_KEY = 'ontap_services';
const MARKETPLACE_KEY = 'ontap_marketplace';
const RENTALS_KEY = 'ontap_rentals';
const RIDES_KEY = 'ontap_rides';
const INITIALIZED_KEY = 'ontap_initialized';

// Demo data to pre-populate the app
const initializeDemoData = () => {
  if (localStorage.getItem(INITIALIZED_KEY)) return;

  // Demo Services
  const demoServices = [
    {
      _id: 'svc_demo_1',
      title: 'Math Tutoring - Calculus & Stats',
      description: 'Junior math major offering tutoring in Calculus I, II, III and Statistics. $15/hour, flexible schedule. Can meet at library or online.',
      category: 'tutoring',
      price: 15,
      priceType: 'hourly',
      location: 'Theresa Hall Library',
      provider: { id: 'demo1', name: 'Alex Johnson', email: 'ajohnson@university.edu' },
      rating: 4.8,
      reviews: [],
      createdAt: new Date(Date.now() - 86400000 * 2).toISOString(),
      status: 'active'
    },
    {
      _id: 'svc_demo_2',
      title: 'Airport Rides - EWR/JFK/LGA',
      description: 'Offering rides to all NYC area airports. Reliable, safe, and affordable. DM to book. Price varies by destination.',
      category: 'rides',
      price: 35,
      priceType: 'fixed',
      location: 'Campus',
      provider: { id: 'demo2', name: 'Maria Santos', email: 'msantos@university.edu' },
      rating: 4.9,
      reviews: [],
      createdAt: new Date(Date.now() - 86400000).toISOString(),
      status: 'active'
    },
    {
      _id: 'svc_demo_3',
      title: 'Essay Proofreading & Editing',
      description: 'English major with 4.0 GPA. Will proofread and edit your essays, research papers, applications. Quick turnaround!',
      category: 'tutoring',
      price: 10,
      priceType: 'fixed',
      location: 'Online',
      provider: { id: 'demo3', name: 'James Chen', email: 'jchen@university.edu' },
      rating: 5.0,
      reviews: [],
      createdAt: new Date(Date.now() - 86400000 * 3).toISOString(),
      status: 'active'
    }
  ];

  // Demo Marketplace Items
  const demoMarketplace = [
    {
      _id: 'mkt_demo_1',
      title: 'MacBook Pro 2021 - 14"',
      description: 'Selling my MacBook Pro 14" M1 Pro. Excellent condition, barely used. Comes with charger and case. Perfect for CS students!',
      itemType: 'electronics',
      condition: 'like-new',
      price: 1200,
      priceType: 'negotiable',
      location: 'Dinneen Hall',
      seller: { id: 'demo4', name: 'Sarah Kim', email: 'skim@university.edu' },
      createdAt: new Date(Date.now() - 86400000).toISOString(),
      status: 'available'
    },
    {
      _id: 'mkt_demo_2',
      title: 'Organic Chemistry Textbook',
      description: 'Wade Organic Chemistry 9th Edition. Some highlighting but in good shape. Required for CHEM 201.',
      itemType: 'textbook',
      condition: 'good',
      price: 45,
      priceType: 'fixed',
      location: 'Campus',
      seller: { id: 'demo5', name: 'Mike Brown', email: 'mbrown@university.edu' },
      createdAt: new Date(Date.now() - 86400000 * 2).toISOString(),
      status: 'available'
    },
    {
      _id: 'mkt_demo_3',
      title: 'Mini Fridge - Perfect for Dorm',
      description: 'Black mini fridge, works great. Moving off campus so need to sell. Pick up from St. Peters Hall.',
      itemType: 'furniture',
      condition: 'good',
      price: 60,
      priceType: 'negotiable',
      location: 'Student Hall',
      seller: { id: 'demo6', name: 'Emma Davis', email: 'edavis@university.edu' },
      createdAt: new Date(Date.now() - 86400000 * 4).toISOString(),
      status: 'available'
    }
  ];

  // Demo Rentals
  const demoRentals = [
    {
      _id: 'rent_demo_1',
      title: 'TI-84 Calculator',
      description: 'TI-84 Plus graphing calculator for rent. Great for math and science exams. Daily or weekly rates available.',
      rentalItemType: 'electronics',
      rentalPeriod: 'daily',
      price: 5,
      deposit: 50,
      location: 'Mac Mahon Student Center',
      owner: { id: 'demo7', name: 'Chris Lee', email: 'clee@university.edu' },
      createdAt: new Date(Date.now() - 86400000).toISOString(),
      status: 'available'
    },
    {
      _id: 'rent_demo_2',
      title: 'Biology Textbook - Campbell',
      description: 'Campbell Biology 12th Edition. Rent for the semester instead of buying! Includes access code.',
      rentalItemType: 'textbook',
      rentalPeriod: 'semester',
      price: 40,
      deposit: 100,
      location: 'Theresa Hall',
      owner: { id: 'demo8', name: 'Lisa Wang', email: 'lwang@university.edu' },
      createdAt: new Date(Date.now() - 86400000 * 5).toISOString(),
      status: 'available'
    }
  ];

  // Demo Rides - dates in the future
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const nextWeek = new Date();
  nextWeek.setDate(nextWeek.getDate() + 7);

  const demoRides = [
    {
      _id: 'ride_demo_1',
      origin: 'Campus',
      destination: 'Newark Airport (EWR)',
      departureTime: new Date(tomorrow.setHours(14, 0, 0, 0)).toISOString(),
      seats: 3,
      price: 25,
      description: 'Heading to EWR for a flight. Can pick up from any dorm. Trunk space available for luggage.',
      driver: { id: 'demo9', name: 'David Park', email: 'dpark@university.edu' },
      passengers: [],
      createdAt: new Date().toISOString(),
      status: 'open'
    },
    {
      _id: 'ride_demo_2',
      origin: 'Campus',
      destination: 'NYC - Times Square',
      departureTime: new Date(nextWeek.setHours(10, 0, 0, 0)).toISOString(),
      seats: 4,
      price: 15,
      description: 'Weekend trip to the city! Meeting at main entrance. Returning same day around 8pm.',
      driver: { id: 'demo10', name: 'Jennifer Martinez', email: 'jmartinez@university.edu' },
      passengers: [],
      createdAt: new Date(Date.now() - 86400000).toISOString(),
      status: 'open'
    }
  ];

  // Save demo data
  localStorage.setItem(SERVICES_KEY, JSON.stringify(demoServices));
  localStorage.setItem(MARKETPLACE_KEY, JSON.stringify(demoMarketplace));
  localStorage.setItem(RENTALS_KEY, JSON.stringify(demoRentals));
  localStorage.setItem(RIDES_KEY, JSON.stringify(demoRides));
  localStorage.setItem(INITIALIZED_KEY, 'true');

  console.log('Demo data initialized!');
};

// Initialize demo data on first load
initializeDemoData();

// Generic helpers
const getItems = (key) => {
  try {
    const items = localStorage.getItem(key);
    return items ? JSON.parse(items) : [];
  } catch (e) {
    console.error('Error reading from localStorage:', e);
    return [];
  }
};

const saveItems = (key, items) => {
  try {
    localStorage.setItem(key, JSON.stringify(items));
    console.log(`Saved ${items.length} items to ${key}`);
  } catch (e) {
    console.error('Error saving to localStorage:', e);
  }
};

const generateId = (prefix) => {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// ==================== SERVICES ====================
export const getServices = (filters = {}) => {
  let services = getItems(SERVICES_KEY);

  if (filters.category) {
    services = services.filter(s => s.category === filters.category);
  }
  if (filters.search) {
    const search = filters.search.toLowerCase();
    services = services.filter(s =>
      s.title.toLowerCase().includes(search) ||
      s.description.toLowerCase().includes(search)
    );
  }

  // Sort
  if (filters.sort === 'price-low') {
    services.sort((a, b) => a.price - b.price);
  } else if (filters.sort === 'price-high') {
    services.sort((a, b) => b.price - a.price);
  } else {
    services.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  return services;
};

export const addService = (serviceData, user) => {
  const services = getItems(SERVICES_KEY);
  const newService = {
    _id: generateId('svc'),
    ...serviceData,
    provider: { id: user.id, name: user.name, email: user.email },
    rating: 0,
    reviews: [],
    createdAt: new Date().toISOString(),
    status: 'active',
  };
  services.push(newService);
  saveItems(SERVICES_KEY, services);
  return newService;
};

export const deleteService = (serviceId, userId) => {
  const services = getItems(SERVICES_KEY);
  const service = services.find(s => s._id === serviceId);
  if (service && service.provider.id === userId) {
    const updated = services.filter(s => s._id !== serviceId);
    saveItems(SERVICES_KEY, updated);
    return true;
  }
  return false;
};

export const getAllServicesAdmin = () => getItems(SERVICES_KEY);

// ==================== MARKETPLACE ====================
export const getMarketplaceItems = (filters = {}) => {
  let items = getItems(MARKETPLACE_KEY);

  if (filters.itemType) {
    items = items.filter(i => i.itemType === filters.itemType);
  }
  if (filters.condition) {
    items = items.filter(i => i.condition === filters.condition);
  }
  if (filters.search) {
    const search = filters.search.toLowerCase();
    items = items.filter(i =>
      i.title.toLowerCase().includes(search) ||
      i.description.toLowerCase().includes(search)
    );
  }

  if (filters.sort === 'price-low') {
    items.sort((a, b) => a.price - b.price);
  } else if (filters.sort === 'price-high') {
    items.sort((a, b) => b.price - a.price);
  } else {
    items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  return items;
};

export const addMarketplaceItem = (itemData, user) => {
  const items = getItems(MARKETPLACE_KEY);
  const newItem = {
    _id: generateId('mkt'),
    ...itemData,
    seller: { id: user.id, name: user.name, email: user.email },
    createdAt: new Date().toISOString(),
    status: 'available',
  };
  items.push(newItem);
  saveItems(MARKETPLACE_KEY, items);
  return newItem;
};

export const deleteMarketplaceItem = (itemId, userId) => {
  const items = getItems(MARKETPLACE_KEY);
  const item = items.find(i => i._id === itemId);
  if (item && item.seller.id === userId) {
    const updated = items.filter(i => i._id !== itemId);
    saveItems(MARKETPLACE_KEY, updated);
    return true;
  }
  return false;
};

export const getAllMarketplaceAdmin = () => getItems(MARKETPLACE_KEY);

// ==================== RENTALS ====================
export const getRentals = (filters = {}) => {
  let rentals = getItems(RENTALS_KEY);

  if (filters.rentalItemType) {
    rentals = rentals.filter(r => r.rentalItemType === filters.rentalItemType);
  }
  if (filters.rentalPeriod) {
    rentals = rentals.filter(r => r.rentalPeriod === filters.rentalPeriod);
  }
  if (filters.search) {
    const search = filters.search.toLowerCase();
    rentals = rentals.filter(r =>
      r.title.toLowerCase().includes(search) ||
      r.description.toLowerCase().includes(search)
    );
  }

  if (filters.sort === 'price-low') {
    rentals.sort((a, b) => a.price - b.price);
  } else if (filters.sort === 'price-high') {
    rentals.sort((a, b) => b.price - a.price);
  } else {
    rentals.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  return rentals;
};

export const addRental = (rentalData, user) => {
  const rentals = getItems(RENTALS_KEY);
  const newRental = {
    _id: generateId('rent'),
    ...rentalData,
    owner: { id: user.id, name: user.name, email: user.email },
    createdAt: new Date().toISOString(),
    status: 'available',
  };
  rentals.push(newRental);
  saveItems(RENTALS_KEY, rentals);
  return newRental;
};

export const deleteRental = (rentalId, userId) => {
  const rentals = getItems(RENTALS_KEY);
  const rental = rentals.find(r => r._id === rentalId);
  if (rental && rental.owner.id === userId) {
    const updated = rentals.filter(r => r._id !== rentalId);
    saveItems(RENTALS_KEY, updated);
    return true;
  }
  return false;
};

export const getAllRentalsAdmin = () => getItems(RENTALS_KEY);

// ==================== RIDES ====================
export const getRides = (filters = {}) => {
  let rides = getItems(RIDES_KEY);

  if (filters.destination) {
    const dest = filters.destination.toLowerCase();
    rides = rides.filter(r =>
      r.destination.toLowerCase().includes(dest) ||
      r.origin.toLowerCase().includes(dest)
    );
  }
  if (filters.search) {
    const search = filters.search.toLowerCase();
    rides = rides.filter(r =>
      r.origin.toLowerCase().includes(search) ||
      r.destination.toLowerCase().includes(search) ||
      r.description?.toLowerCase().includes(search)
    );
  }

  // Filter out past rides
  const now = new Date();
  rides = rides.filter(r => new Date(r.departureTime) > now);

  // Sort by departure time
  rides.sort((a, b) => new Date(a.departureTime) - new Date(b.departureTime));

  return rides;
};

export const addRide = (rideData, user) => {
  const rides = getItems(RIDES_KEY);
  const newRide = {
    _id: generateId('ride'),
    ...rideData,
    driver: { id: user.id, name: user.name, email: user.email },
    passengers: [],
    createdAt: new Date().toISOString(),
    status: 'open',
  };
  rides.push(newRide);
  saveItems(RIDES_KEY, rides);
  return newRide;
};

export const deleteRide = (rideId, userId) => {
  const rides = getItems(RIDES_KEY);
  const ride = rides.find(r => r._id === rideId);
  if (ride && ride.driver.id === userId) {
    const updated = rides.filter(r => r._id !== rideId);
    saveItems(RIDES_KEY, updated);
    return true;
  }
  return false;
};

export const getAllRidesAdmin = () => getItems(RIDES_KEY);

// ==================== ADMIN STATS ====================
export const getListingsStats = () => {
  return {
    services: getItems(SERVICES_KEY).length,
    marketplace: getItems(MARKETPLACE_KEY).length,
    rentals: getItems(RENTALS_KEY).length,
    rides: getItems(RIDES_KEY).filter(r => new Date(r.departureTime) > new Date()).length,
  };
};

// ==================== ADMIN DELETE (force delete) ====================
export const adminDeleteListing = (type, itemId) => {
  const keyMap = {
    services: SERVICES_KEY,
    marketplace: MARKETPLACE_KEY,
    rentals: RENTALS_KEY,
    rides: RIDES_KEY,
  };
  const key = keyMap[type];
  if (!key) return false;

  const items = getItems(key);
  const updated = items.filter(i => i._id !== itemId);
  saveItems(key, updated);
  return true;
};

// Get user's own listings
export const getUserListings = (userId) => {
  return {
    services: getItems(SERVICES_KEY).filter(s => s.provider?.id === userId),
    marketplace: getItems(MARKETPLACE_KEY).filter(m => m.seller?.id === userId),
    rentals: getItems(RENTALS_KEY).filter(r => r.owner?.id === userId),
    rides: getItems(RIDES_KEY).filter(r => r.driver?.id === userId),
  };
};

export default {
  getServices,
  addService,
  deleteService,
  getAllServicesAdmin,
  getMarketplaceItems,
  addMarketplaceItem,
  deleteMarketplaceItem,
  getAllMarketplaceAdmin,
  getRentals,
  addRental,
  deleteRental,
  getAllRentalsAdmin,
  getRides,
  addRide,
  deleteRide,
  getAllRidesAdmin,
  getListingsStats,
  adminDeleteListing,
  getUserListings,
};
